import { gql } from 'graphql-request'

class CustomerUserQueries {
  getAll = gql`
    query CustomerUsers($where: CustomerUserWhereInput, $orderBy: CustomerUserExtendedOrderByInput) {
      customerUsersConnection(where: $where, orderBy: $orderBy) {
        edges {
          node {
            id
            user {
              displayName
              email
            }
            role
            assignedPlaces {
              id
              name
            }
            customer {
              id
            }
            createdAt
          }
        }
      }
    }
  `
}

const customerUserQueries = new CustomerUserQueries()

export default customerUserQueries
